import { Box, Button, IcPaymentTypeCash, IcPaymentTypeCreditCard, IcPaymentTypeGiftCard, IcPaymentTypeLoyaltyPoint, Text } from '@fozito/common-ui';
import { QRCode } from 'antd';
import { ICustomerPaymentDetail } from 'modules/POS/Cashier/socket.interface';
import React from 'react';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';
import { PaymentMethod } from './PaymentMethod';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const AcceptButtons = styled.div`
width: 50%;
display: flex;
gap: 16px;
align-self: center;
padding-bottom: 16px;
margin-top: 16px;
button {
  flex: 1;
}
`;
interface QrPaymentsProps {
  qrCode?: string;
  qrCodeImg?: string;
  QRName?: string;
  total: number;
  onCancel?: () => void;
  onConfirm?: () => void;
  payments?: ICustomerPaymentDetail;
}

const QrPayments: React.FC<QrPaymentsProps> = ({
  qrCode = '',
  qrCodeImg = '',
  QRName = '',
  total,
  onCancel,
  onConfirm,
  payments,
}) => {
  return (
    <Container>
      <Text title_h2_32_semibold style={{ margin: 0, fontSize: 70 }}>
        {formatCurrency(total)}
      </Text>
      <Box alignSelf='stretch' display='flex' flexDirection='column' gap={8} padding={16}>
        {!!payments?.cash && <PaymentMethod
          icon={<IcPaymentTypeCash />}
          label="Cash"
          value={payments?.cash || 0}
          chance={payments?.chanceCash || 0}
        />}
        {!!payments?.card && <PaymentMethod
          icon={<IcPaymentTypeCreditCard />}
          label="Card"
          value={payments?.card || 0}
          isEven
        />}
        {!!payments?.loyalty && <PaymentMethod
          icon={<IcPaymentTypeLoyaltyPoint />}
          label="Loyalty"
          value={payments?.loyalty || 0}
          loyaltyAvailable={0}
        />}
        {!!payments?.loyalty && <PaymentMethod
          icon={<IcPaymentTypeGiftCard />}
          label="Gift Card"
          value={payments?.giftCard || 0}
          isEven
          giftCard={!!payments?.giftCard}
          giftCardAvailable={payments?.giftCardAvailable}
          giftCardBalance={payments?.giftCardBalance}
        />}
      </Box>
      <Content>
        <Text title_h6_20_regular>Scan to pay with {QRName}</Text>
        <QRCode value={qrCode} size={470} style={{ marginTop: 20 }} />
        <img src={qrCodeImg} alt={QRName} style={{ width: 470, height: 470 }} />
      </Content>
      <AcceptButtons>
        {onConfirm && <Button type_cancel onClick={onCancel}>Cancel</Button>}
        {onConfirm && <Button type_primary onClick={onConfirm}>Ok</Button>}
      </AcceptButtons>
    </Container>
  );
};

export default QrPayments;
